import { EnumEndpoints, EnumEndpointsName, EnumMethod } from "@/constants/app/type";
import { callbackVoucherValidate } from "./callbacks/callbackVoucherValidate";
import { callbackVoucherGetAll } from "./callbacks/callbackVoucherGetAll";
import { EnumAPIKey } from "@/constants/app/api";
import { fetchVouchersAll } from "@/utils/voucher/fetchVouchersAll";
import { VouchersGetAllBody } from "./voucherApiV3.types";

export const voucherEndpoints = {
  [EnumEndpointsName.VOUCHER_GET_ALL]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.VOUCHER_GET_ALL,
    api: EnumAPIKey.API_BASE,
    caller: callbackVoucherGetAll,
    callerService: (body: VouchersGetAllBody) => fetchVouchersAll(body),
  },
  [EnumEndpointsName.VOUCHER_CUSTOMER_GET_ALL]: {
    method: EnumMethod.GET,
    endpoint: EnumEndpoints.VOUCHER_CUSTOMER_GET_ALL,
    api: EnumAPIKey.API_BASE
  },
  [EnumEndpointsName.VOUCHER_VALIDATE]: {
    method: EnumMethod.POST,
    endpoint: EnumEndpoints.VOUCHER_VALIDATE,
    api: EnumAPIKey.API_BASE,
    caller: callbackVoucherValidate,
  }
}